module.exports = __webpack_public_path__ + "img/6.00ffc5ef.jpg";